var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisruptionSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M51.1114 29.3336H56.4447C57.9175 29.3336 59.1114 30.5275 59.1114 32.0002C59.1114 33.473 57.9175 34.6669 56.4447 34.6669H51.1114C49.6386 34.6669 48.4447 33.473 48.4447 32.0002C48.4447 30.5275 49.6386 29.3336 51.1114 29.3336ZM8.44474 29.3336H13.7781C15.2508 29.3336 16.4447 30.5275 16.4447 32.0002C16.4447 33.473 15.2508 34.6669 13.7781 34.6669H8.44474C6.97198 34.6669 5.77808 33.473 5.77808 32.0002C5.77808 30.5275 6.97198 29.3336 8.44474 29.3336ZM32.4447 5.33356C33.9175 5.33356 35.1114 6.52746 35.1114 8.00022V13.3336C35.1114 14.8063 33.9175 16.0002 32.4447 16.0002C30.972 16.0002 29.7781 14.8063 29.7781 13.3336V8.00022C29.7781 6.52746 30.972 5.33356 32.4447 5.33356ZM32.4447 48.0002C33.9175 48.0002 35.1114 49.1941 35.1114 50.6669V56.0002C35.1114 57.473 33.9175 58.6669 32.4447 58.6669C30.972 58.6669 29.7781 57.473 29.7781 56.0002V50.6669C29.7781 49.1941 30.972 48.0002 32.4447 48.0002Z",
    fill: "#EBA183"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4445 40C36.8627 40 40.4445 36.4183 40.4445 32C40.4445 27.5818 36.8627 24 32.4445 24C28.0262 24 24.4445 27.5818 24.4445 32C24.4445 36.4183 28.0262 40 32.4445 40Z",
    fill: "#EBA183"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisruptionSingle);
export default __webpack_public_path__ + "static/media/disruption_single.f8b916491d99dcc1a86261695c3b8f87.svg";
export { ForwardRef as ReactComponent };